import { useState } from "react";
import emailjs from "emailjs-com";

import iconLocalisation from '@assets/icons/icons8_marker.svg';
import iconPhone from '@assets/icons/icons8_shake_phone_3.svg';
import iconEmail from '@assets/icons/icons8_envelope.svg';
import iconAdresse from '@assets/icons/icons8_At_sign.svg';
import iconSiteWeb from '@assets/icons/icons8_website.svg';

function ContactPage() {

  const [formData, setFormData] = useState({
    civilite: "",
    prenom: "",
    nom: "",
    email: "",
    indicatif: "+225",
    telephone: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const sendEmail = async (e) => {
    e.preventDefault();

    const formDataSend = new FormData();
    formDataSend.append("civilite", formData.civilite);
    formDataSend.append("prenom", formData.prenom);
    formDataSend.append("nom", formData.nom);
    formDataSend.append("email", formData.email);
    formDataSend.append("indicatif", formData.indicatif);
    formDataSend.append("telephone", formData.telephone);
    formDataSend.append("message", formData.message);

    const response = await fetch("https://ton-domaine.com/contact_process.php", {
      method: "POST",
      body: formDataSend
    });

    const result = await response.json();

    if (result.success) {
      alert(result.success);
    } else {
      alert(result.error);
    }
  };

  return (
    <div className="w-full h-screen bg-cream-50 overflow-x-hidden pt-16">
      
      {/* Header */}
      <div className="pt-16 pb-10 text-center">
        <h1 className="text-5xl font-bold" style={{color:'#071268'}}>Contactez-Nous</h1>
        <p className="text-gray-600 mt-2">Écrivez-nous et nous vous contacterons.</p>
      </div>

      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10 px-4 md:px-0">

        {/* Form */}
        <div className="md:col-span-2">
          <form className="space-y-6" onSubmit={sendEmail}>

            {/* Civilité */}
            <div>
              <label className="block font-semibold mb-2">Civilité</label>
              <div className="flex items-center gap-6 text-sm">

                {["M", "Mme", "Mlle", "Autre"].map((c) => (
                  <label key={c} className="flex items-center gap-2">
                    <input 
                      type="radio" 
                      name="civilite"
                      value={c}
                      onChange={handleChange}
                    />
                    {c}
                  </label>
                ))}

              </div>
            </div>

            {/* Prénom & Nom */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block mb-1 font-medium">Prénom</label>
                <input 
                  type="text" 
                  name="prenom"
                  className="w-full border rounded-md p-3"
                  onChange={handleChange}
                />
              </div>
              <div>
                <label className="block mb-1 font-medium">Nom</label>
                <input 
                  type="text"
                  name="nom"
                  className="w-full border rounded-md p-3"
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* Email / Téléphone */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block mb-1 font-medium">Email</label>
                <input 
                  type="email"
                  name="email"
                  className="w-full border rounded-md p-3"
                  onChange={handleChange}
                />
              </div>

              <div>
                <label className="block mb-1 font-medium">Téléphone</label>
                <div className="flex gap-2">

                  {/* Indicatif */}
                  <select
                    name="indicatif"
                    className="w-32 border rounded-md p-3 bg-gray-100 text-center"
                    defaultValue="+225"
                    onChange={handleChange}
                  >
                    <option value="+225">+225</option>
                    <option value="+226">+226</option>
                    <option value="+227">+227</option>
                    <option value="+228">+228</option>
                    <option value="+229">+229</option>
                    <option value="+221">+221</option>
                    <option value="+223">+223</option>
                    <option value="+224">+224</option>
                  </select>

                  {/* Numéro */}
                  <input 
                    type="text"
                    name="telephone"
                    placeholder="Numéro"
                    className="w-full border rounded-md p-3"
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>

            {/* Message */}
            <div>
              <label className="block mb-1 font-medium">Message</label>
              <textarea
                name="message"
                className="w-full border rounded-md p-3 h-32"
                onChange={handleChange}
              ></textarea>
            </div>

            {/* Submit */}
            <div className="flex justify-end">
              <button
                type="submit"
                className="bg-yellow-400 hover:bg-yellow-500 w-40 py-3 rounded-md font-semibold text-xl"
              >
                Envoyer
              </button>
            </div>
          </form>
        </div>

        {/* Contact Info */}
        <div className="bg-yellow-50 p-8 rounded-lg shadow-sm space-y-4">
          <div className="flex gap-4 items-center mb-8">
            <img src={iconLocalisation} className="w-6 h-6" />
            <div>
              <h2 className="font-bold text-xl">KUDHI</h2>
              <p className="text-gray-700 text-lg">Grand Bassam, rue des 20233</p>
            </div>
          </div>

          <div className="flex gap-4 items-center mb-8">
            <img src={iconPhone} className="w-6 h-6" />
            <div>
              <h3 className="font-bold text-xl">Téléphone</h3>
              <p className="text-gray-700 text-lg">+225 05 06 76 77 17</p>
            </div>
          </div>

          <div className="flex gap-4 items-center mb-8">
            <img src={iconEmail} className="w-6 h-6" />
            <div>
              <h3 className="font-bold text-xl">Email</h3>
              <p className="text-gray-700 text-lg">info@kudhi.net</p>
            </div>
          </div>

          <div className="flex gap-4 items-center mb-8">
            <img src={iconAdresse} className="w-6 h-6" />
            <div>
              <h3 className="font-bold text-xl">Adresse</h3>
              <p className="text-gray-700 text-lg">06 BP 2243 Abidjan 06</p>
            </div>
          </div>

          <div className="flex gap-4 items-center">
            <img src={iconSiteWeb} className="w-6 h-6" />
            <div>
              <h3 className="font-bold text-xl">Site web</h3>
              <p className="text-gray-700 text-lg">https://www.kudhi.net/</p>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default ContactPage;